import "./Tooltip.css"
function Tooltip({ text, classNameContainer, classNameIcon,classNameBoxText }) {

    return (
        <div className={"con-tooltip " + (classNameContainer ? classNameContainer : "")}>
            <i className={"fas fa-info-circle " + (classNameIcon ? classNameIcon : "")} style={{ marginLeft: "10px", fontSize: "18px" }}></i>
            <div>
                <div className={"tooltip "+ (classNameBoxText ? classNameBoxText : "")}>
                    <div className="content_tooltip_text">{text} </div>
                </div>
            </div>
        </div>

    );
}

export default Tooltip;